<template>
  <div class="row form-horizontal">
    <div class="form-group">
      <label class="col-md-3 control-label text-right"
        >{{ pageName }}CSV：</label
      >
      <div class="col-md-6">
        <div class="input-group">
          <input
            id="file-name"
            v-model="uploadFileName"
            :placeholder="$t('common.csvFile')"
            :disabled="isDisabled"
            type="text"
            class="form-control"
          />
          <label class="input-group-btn">
            <span class="btn btn-primary">
              {{ $t('common.import') }}
              <input
                id="file-select"
                v-validate="ValidRules.csv"
                :data-vv-as="$t('common.csvFile')"
                @change="selectedFile"
                name="csv"
                type="file"
                class="hidden"
              />
            </span>
          </label>
        </div>
        <p>
          {{ $t('common.csvFileUploadDescription') }}
        </p>
      </div>
      <div class="col-md-3">
        <button
          :disabled="!isDisabled"
          @click="upload()"
          class="btn btn-primary"
        >
          {{ $t('common.upload') }}
        </button>
      </div>
    </div>
    <div v-show="validator.has('csv')" class="col-md-offset-3 col-md-6">
      <div class="alert alert-danger" role="validater">
        <ul>
          <li v-for="(message, index) in validator.collect('csv')" :key="index">
            {{ message }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import CsvRequest from '@/http/CsvRequest'
import ValidRules from '@/validator/CsvUploadRules'
export default {
  props: ['pageName', 'format'],
  data() {
    return {
      uploadFile: null,
      uploadFileName: '',
      isDisabled: false,
      ValidRules: ValidRules,
    }
  },
  methods: {
    // 初期化
    initialize: function(fileName = '') {
      this.uploadFileName = fileName
      this.uploadFile = null
      this.isDisabled = false
    },
    selectedFile: function(event) {
      const file = event.target.files[0]

      if (file === undefined) {
        this.initialize()
        return
      }

      this.$validator.validate('csv').then((result) => {
        if (result) {
          this.uploadFileName = file.name
          this.uploadFile = file
          this.isDisabled = true
        } else {
          this.initialize(file.name)
        }
      })
    },
    upload: function() {
      let formData = new FormData()
      formData.append('csvfile', this.uploadFile)
      formData.append('format', this.format)
      const request = new CsvRequest()
      request
        .uploadCsv(formData)
        .then((res) => {
          this.$emit('uploaded', true, res.data)
        })
        .catch((error) => {
          this.$emit('uploaded', false, error.response.data)
        })
        .finally(() => {
          this.initialize()
        })
    },
  },
}
</script>
